export default __webpack_public_path__ + "static/media/sfx-pop3.4c761e1b.mp3";